import { useState } from "react";
import StackItem from "./StackItem";

function parseString(input) {
  return input.split(",").map((str) => str.trim());
}

function TeckStack({ title, data }) {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
    console.log("Mouse Leave", hoveredIndex);
  };

  const handleMouseLeave = () => {
    console.log("Mouse Leave", hoveredIndex);
    setHoveredIndex(null);
  };

  const imgBox = {
    box: {
      width: "fit-content",
    },
    img: {
      width: "8rem",
    },
  };

  return (
    <div
      className="skills mt-5 mt-lg-4 d-flex align-items-center  justify-content-between flex-wrap row-gap-4  "
      data-aos="fade-up"
    >
      <div className="col-lg-12" style={imgBox.box}>
        <p className="m-0 fs-6 fw-medium ">{title} :</p>
      </div>
      <div className="skill d-flex col-lg-12 justify-content-center  justify-content-md-start  gap-4  flex-wrap   justify-content-lg-between    ">
        {data.map((stackUrl, index) => (
          <StackItem
            stack={parseString(stackUrl)}
            key={index}
            style={imgBox}
            handleStyleImg={{
              index,
              handleMouseEnter,
              handleMouseLeave,
              hoveredIndex,
            }}
            src={"https://skillicons.dev/icons?i=" + stackUrl}
          />
        ))}
      </div>
    </div>
  );
}

export default TeckStack;
